import {
  ListLessonResourceFilters,
  listLessonResources,
} from '@/data/services/resourceServices';

export const resourceQueries = {
  all: ['resources'] as const,

  lessonList: (lessonId: number, filters: ListLessonResourceFilters = {}) => ({
    queryKey: [
      ...resourceQueries.all,
      'lessonList',
      { lessonId, filters },
    ] as const,
    queryFn: () => listLessonResources(lessonId, filters),
  }),
};
